export default {
    namespaced: true,
    state: {
      userInfo: {}
    },
    mutations: {
      add(state, item) {
        state.userInfo = item;
        if (item.headimgBase64) {
          state.userInfo.defaultHeader = "data:image/png;base64," + item.headimgBase64;
        } else {
          state.userInfo.defaultHeader = "@/assets/default.png";
        }
      },
      updateMotto(state, motto) {
        state.userInfo.motto = motto;
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/store/user.js